import * as paths from '../../Providers/paths';
import * as profileRoutines from './profileRoutines';
import * as rootSelectors from '../../selectors/root';
import * as toastRoutines from '../../sagas/routines/toastRoutines';
import { all, call, cancel, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { rsf } from '../../globals/firebase';

export function* toggleProfilePicRequiredSaga(action) {
    const active_event_id = yield select(rootSelectors.selectActiveEventId);

    try {
        yield call(rsf.database.patch, `${paths.moduleConfig(active_event_id, 'userConfiguration')}/`, {
            isProfilePicRequired: action.payload.isProfilePicRequired,
        });
        yield put(toastRoutines.setToastSuccess('Profile pic settings updated!'));
        yield put(profileRoutines.toggleProfilePicRequired.success(action.payload.isProfilePicRequired));
    } catch (error) {
        yield put(toastRoutines.setToastError('Error updating profile pic settings!'));
        yield put(profileRoutines.toggleProfilePicRequired.failure(error));
    }
}

function* syncProfileSaga() {
    const active_event_id = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.eventPath(active_event_id, 'userConfiguration'), {
        successActionCreator: profileRoutines.syncProfile.success,
        failureActionCreator: profileRoutines.syncProfile.failure,
    });
}

export function* resetProfileSync() {
    yield put(profileRoutines.stopSyncingProfile.trigger());
    yield put(profileRoutines.syncProfile.trigger());
}

export default function* rootSaga() {
    yield all([takeEvery(profileRoutines.toggleProfilePicRequired.TRIGGER, toggleProfilePicRequiredSaga)]);
    while (yield take(profileRoutines.syncProfile.TRIGGER)) {
        const bgProfileSync = yield fork(syncProfileSaga);
        yield take(profileRoutines.stopSyncingProfile.TRIGGER);
        yield cancel(bgProfileSync);
    }
}
